module.exports = __webpack_public_path__ + "static/squiggly2-b7bc3f0bd22c874ec4f0d1a5daa6a32c.png";